export const SCRIPTS = {
  // TODO: This library enables the automatic resizing of the height and width of both same and
  // cross domain iFrames to fit their contained content. It provides a range of features
  // to address the most common issues with using iFrames. See for more detail:
  // https://confluence.int.abnamro.com/pages/viewpage.action?spaceKey=CROW&title=How-to%3A+iFrame+pages+on+the+open+domain
  deq: 'https://www.abnamro.nl/shared/deq/main.js',
  iframeResizer: '/scripts/iframeResizer.min.js',
  recaptcha: 'https://www.google.com/recaptcha/api.js',
};

export const SCROLL_WRAPPER_TYPES = {
  nav: 'nav',
  image: 'image',
  card: 'card',
};

export const DOMAINS = {
  development: 'https://dpkn-d.azure.nl.eu.abnamro.com',
  acceptance: 'https://doorpakken-a.abnamro.nl',
  production: 'https://doorpakken.abnamro.nl',
  open: 'https://www.abnamro.nl',
};

export const VIDEO_TYPES = {
  contentful: 'Contentful-Video',
  youtube: 'Youtube-Embed',
  linkedin: 'LinkedIn-Video',
};

export const ELEMENT_IDS = {
  body: 'body',
};
